import { DateField } from '@internal/ui-kit/components/admin'
import { AttachmentLink } from '@internal/ui-kit/components/app/AttachmentsList'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@internal/ui-kit/components/ui/table'
import { fromApiUtc } from '@internal/ui-kit/lib/fromApiUtc'
import { useInsurances } from './useUserProfileData'

/**
 * The combined page's "Insurance" tab (HATCH-101 round 4 — split out of the
 * original combined "Loyalty & insurance" tab into its own tab per ticket
 * feedback). `getInsurances` — `table2`, read-only.
 */
export function InsuranceTab({ userId }: { userId: string }) {
  const { insurances, isPending } = useInsurances(userId)

  if (isPending) return <p className="text-muted-foreground text-sm">Loading insurance…</p>
  if (insurances.length === 0) return <p className="text-muted-foreground text-sm">No insurance on file.</p>

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Provider</TableHead>
          <TableHead>Membership ID</TableHead>
          <TableHead>Membership type</TableHead>
          <TableHead>Date of birth</TableHead>
          <TableHead>Verified at</TableHead>
          <TableHead>Created at</TableHead>
          <TableHead>Membership card</TableHead>
          <TableHead>Government ID</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {insurances.map((insurance) => (
          <TableRow key={insurance.insurance_id}>
            <TableCell>{insurance.insurance_provider?.name ?? '—'}</TableCell>
            <TableCell>{insurance.membership_id ?? '—'}</TableCell>
            <TableCell>{insurance.membership_type ?? '—'}</TableCell>
            <TableCell>
              {insurance.date_of_birth ? (
                <DateField record={insurance} source="date_of_birth" />
              ) : (
                '—'
              )}
            </TableCell>
            <TableCell>
              {insurance.verified_at ? (
                <DateField record={insurance} source="verified_at" showTime transform={fromApiUtc} />
              ) : (
                '—'
              )}
            </TableCell>
            <TableCell>
              {insurance.created_at ? (
                <DateField record={insurance} source="created_at" showTime transform={fromApiUtc} />
              ) : (
                '—'
              )}
            </TableCell>
            <TableCell>
              {insurance.membership_card_file?.url ? (
                <AttachmentLink attachment={insurance.membership_card_file} />
              ) : (
                '—'
              )}
            </TableCell>
            <TableCell>
              {insurance.government_id_file?.url ? (
                <AttachmentLink attachment={insurance.government_id_file} />
              ) : (
                '—'
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
